import moment from 'moment';
import React from 'react';

import './Diagnosis.scss';
import { ICONS } from 'src/common/constants';
import FontAwesomeIcon from '../Icon';
import NewBadge from 'src/components/NewBadge/NewBadge';

interface DiagnosisProps {
  asset: string;
  issueType: string;
  location?: string;
  expiresAt?: string | null;
  label?: string;
  onEditAsset?: () => void;
}

const Diagnosis = ({
  asset,
  issueType,
  location,
  expiresAt,
  label,
  onEditAsset,
}: DiagnosisProps) => {
  const days: number = moment().diff(moment(expiresAt), 'days');

  return (
    <div className="diagnosis-wrapper">
      <table className="diagnosis-table">
        <thead>
          <tr>
            <th className="diagnosis-header-cell">{label ?? 'Asset'}</th>
            {location && <th className="diagnosis-header-cell">Location</th>}
            <th className="diagnosis-header-cell">Issue Type</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td className="diagnosis-data-cell">
              <div className="diagnosis-cell-label">
                <div className="diagnosis-asset-icon">
                  <FontAwesomeIcon glyph={ICONS[asset]} weight="light" />
                </div>
                {asset}
                {onEditAsset && (
                  <>
                    <button
                      className="diagnosis-edit-button"
                      onClick={onEditAsset}
                      aria-label="Change asset"
                    >
                      <FontAwesomeIcon glyph="pencil" weight="light" />
                    </button>
                  </>
                )}
              </div>
            </td>
            {location && (
              <td className="diagnosis-data-cell">
                <div className="diagnosis-cell-label">{location}</div>
              </td>
            )}
            <td className="diagnosis-data-cell">
              <div className="diagnosis-cell-label">
                <div className="diagnosis-asset-icon">
                  <FontAwesomeIcon glyph={ICONS[issueType]} weight="light" />
                </div>
                {issueType}
              </div>
            </td>
          </tr>
        </tbody>
      </table>
      {expiresAt && days >= -30 && (
        <div className="diagnosis-expiry-banner">
          <div className="diagnosis-expiry-indicator">
            <FontAwesomeIcon glyph="exclamation" weight="solid" />
          </div>
          <div>
            Act fast, the warranty expires on{' '}
            <strong>{moment(expiresAt).format('MMM D, YYYY')}.</strong>
          </div>
        </div>
      )}
    </div>
  );
};

export default Diagnosis;
